import _classCallCheck from "/Users/ashokmandal/tmp/react-app/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/Users/ashokmandal/tmp/react-app/node_modules/@babel/runtime/helpers/esm/createClass";
import _possibleConstructorReturn from "/Users/ashokmandal/tmp/react-app/node_modules/@babel/runtime/helpers/esm/possibleConstructorReturn";
import _getPrototypeOf from "/Users/ashokmandal/tmp/react-app/node_modules/@babel/runtime/helpers/esm/getPrototypeOf";
import _get from "/Users/ashokmandal/tmp/react-app/node_modules/@babel/runtime/helpers/esm/get";
import _inherits from "/Users/ashokmandal/tmp/react-app/node_modules/@babel/runtime/helpers/esm/inherits";
import AnnotationShape from './annotation-shape';
import { pluckNumber, clampNumber } from '../../../../fc-core/src/lib';
var DEFAULT_POLYGON_SIDES = 5,
    DEFAULT_ANGLE_START = 0;

var PolygonAnnotation =
/*#__PURE__*/
function (_AnnotationShape) {
  _inherits(PolygonAnnotation, _AnnotationShape);

  function PolygonAnnotation() {
    _classCallCheck(this, PolygonAnnotation);

    return _possibleConstructorReturn(this, _getPrototypeOf(PolygonAnnotation).apply(this, arguments));
  }

  _createClass(PolygonAnnotation, [{
    key: "getName",
    value: function getName() {
      return 'polygon';
    }
  }, {
    key: "configureAttributes",
    value: function configureAttributes() {
      var a = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

      _get(_getPrototypeOf(PolygonAnnotation.prototype), "configureAttributes", this).call(this, a);

      var b = this,
          c = b.rawConfig;
      b.config.sides = pluckNumber(clampNumber(c.sides, 3), DEFAULT_POLYGON_SIDES), b.config.startAngle = pluckNumber(parseFloat(c.startAngle), DEFAULT_ANGLE_START), b.config.xRadius = pluckNumber(parseFloat(c.radius), 0), b.config.elementType = 'polypath';
    }
  }, {
    key: "updateAttr",
    value: function updateAttr() {
      var a,
          b = this,
          c = b.config,
          d = c.calculatedAttrs;
      a = [c.sides, pluckNumber(d.x, b.getScaledVal(c.x, !0)), pluckNumber(d.y, b.getScaledVal(c.y, !1)), b.getScaledVal(c.xRadius), c.startAngle, 0], b._setConfig('attr', {
        polypath: a
      });
    }
  }, {
    key: "_getAnnotationAttrs",
    value: function _getAnnotationAttrs() {
      var a = this,
          b = a.config,
          c = a._getConfig('attr') || {},
          d = b.sides,
          e = b.x,
          f = b.y,
          g = b.color,
          h = b.startAngle,
          i = b.borderColor,
          j = b.borderThickness,
          k = b.dashArrayStr,
          l = b.xRadius;
      return c.fill = g, c.stroke = i, c['stroke-width'] = j, c['stroke-dasharray'] = k, c.polypath = c.polypath || [d, a.getScaledVal(e, !0), a.getScaledVal(f, !1), a.getScaledVal(l), h, 0], c;
    }
  }]);

  return PolygonAnnotation;
}(AnnotationShape);

export default PolygonAnnotation;